import script from "./selector.vue?vue&type=script&setup=true&lang=js"
export * from "./selector.vue?vue&type=script&setup=true&lang=js"

import "./selector.vue?vue&type=style&index=0&id=408bd2d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408bd2d1"]])

export default __exports__